import React, { Component } from "react";

export class Cursor extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    render() {
        return (
			<div className="Cursor" style={{left: this.props.pos.x*8, top: this.props.pos.y*12, position:'absolute', backgroundColor: this.props.color}}>
                {/*this.props.pos.x}, {this.props.pos.y*/}
			</div>
        );
    }
}

export default Cursor;
